import type { ReactNode } from "react";

export function QuotesLineItemText2({ children }: { children: ReactNode }) {
  return (
    <div className="text-[12px] font-light text-content-secondary">
      {children}
    </div>
  );
}
